import { createActionGroup } from '@ngrx/store';

export const SocieteEspaceActions = createActionGroup({
  source: 'Societe Espace',
  events: {}
});
